import React from 'react';
import type { TrustBoxProps } from './types';

export const TrustBoxCarousel: React.FC<TrustBoxProps> = ({
  ref,
  theme,
  clickable,
  ...rest
}) => (
  <div
    ref={ref}
    style={clickable ? {} : { pointerEvents: 'none', userSelect: 'none' }}
    class="trustpilot-widget"
    data-locale="it-IT"
    theme={theme}
    data-template-id="53aa8912dec7e10d38f59f36"
    data-businessunit-id="5cacae5d7b08650001e13ded"
    data-style-height="140px"
    data-style-width="100%"
    data-stars="4,5"
    data-review-languages="it"
    {...rest}
  >
    <a href="https://it.trustpilot.com/review/dove.it" target="_blank" rel="noopener noreferrer">Trustpilot</a>
  </div>
);
